import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useFormikContext } from "formik";
import EN from "../../locales/en";
import Button from "../Button";
import CheckboxField from "./partials/CheckboxField";
import SelectField from "./partials/SelectField";

const AdditionalSupportModal = ({
  open,
  setOpen,
  supplierTermsInfo,
  clearPsrOptions,
  values,
}) => {
  const { setFieldValue } = useFormikContext();

  const handleCancel = () => {
    clearPsrOptions();
    setOpen(false);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    const updatedOptions = values.psr.options.map((option) => {
      if (String(option.id) === name) {
        const updatedOption = { ...option };
        if (checked) {
          updatedOption.selected = true;
        } else {
          delete updatedOption.selected;
        }
        return updatedOption;
      }
      return option;
    });

    setFieldValue("psr.options", updatedOptions);
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    const optionId = name.replace("Select", "");

    const updatedOptions = values.psr.options.map((option) => {
      if (String(option.id) === optionId) {
        option.childPSRs.data = option.childPSRs.data.map((child) => {
          if (child.displayName === value) {
            child.selected = true;
            return child;
          } else {
            delete child.selected;
            return child;
          }
        });
        return option;
      }
      return option;
    });

    setFieldValue("psr.options", updatedOptions);
  };

  const renderFormFields = () => {
    if (!supplierTermsInfo?.psr?.options) return null;

    return (
      <div>
        {supplierTermsInfo.psr.options.map((option) => {
          if (
            option.childPSRs &&
            option.childPSRs.data &&
            option.childPSRs.type === "dropdown"
          ) {
            return (
              <div key={option.id}>
                <CheckboxField
                  label={option.displayName}
                  name={option.id}
                  onChange={handleCheckboxChange}
                  checked={
                    values.psr.options.find((opt) => opt.id === option.id)
                      ?.selected || false
                  }
                />
                {values.psr.options.find((opt) => opt.id === option.id)
                  ?.selected && (
                  <div className="ml-6">
                    <SelectField
                      name={`${option.id}Select`}
                      value={
                        values.psr.options
                          .find((opt) => opt.id === option.id)
                          ?.childPSRs?.data.find((child) => child.selected)
                          ?.displayName || ""
                      }
                      options={option.childPSRs.data.map(
                        (child) => child.displayName
                      )}
                      onChange={handleSelectChange}
                    />
                  </div>
                )}
              </div>
            );
          }
          return (
            <CheckboxField
              key={option.id}
              label={option.displayName}
              name={option.id}
              onChange={handleCheckboxChange}
              checked={
                values.psr.options.find((opt) => opt.id === option.id)
                  ?.selected || false
              }
            />
          );
        })}
      </div>
    );
  };

  return (
    <Dialog className="relative z-10" open={open} onClose={() => {}}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-dark-gray bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full justify-center p-4 text-center items-start sm:p-0">
          <DialogPanel
            transition
            className="relative sm:my-8 sm:w-full sm:max-w-[645px] transform overflow-hidden transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="rounded-[24px] bg-white text-left shadow-xl overflow-hidden p-8">
              <h2 className="text-[22px] font-bold mt-6">
                {EN.switch.additional_support.modal.title}
              </h2>
              <p className="leading-[1.5] mt-2">
                {EN.switch.additional_support.modal.description}
              </p>
              <div className="mt-6 border-t border-[#afb6b9]">
                {renderFormFields()}
              </div>
              <div className="mt-6 border-t border-[#afb6b9] pt-8">
                <div className="flex justify-between gap-6">
                  <Button
                    fullWidth
                    type="button"
                    variant="tertiary"
                    onClick={() => handleCancel()}
                  >
                    {EN.switch.additional_support.modal.cancel_button}
                  </Button>
                  <Button
                    fullWidth
                    type="button"
                    onClick={() => setOpen(false)}
                  >
                    {EN.switch.additional_support.modal.confirm_button}
                  </Button>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default AdditionalSupportModal;
